module.exports = __webpack_public_path__ + "static/media/contribute-card-bg.483ce280.png";